import React, { Component } from 'react'
import { DialogContent, IconButton } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'

export default class PDFDialogView extends Component {
  render () {
    const { cpa, closeCallback } = this.props
    const urlPdf = `${process.env.REACT_APP_PDF_URL}${cpa.numero}.pdf`

    return (
      <DialogContent className='text-center'>
        <IconButton onClick={closeCallback} style={{ margin: '0', padding: '0', float: 'right' }}><CancelIcon /></IconButton>
        <h2>CTG: {cpa.numero}</h2>
        <div style={{ width: '600', margin: '0 auto' }}>
          {urlPdf && (
            <iframe title='pdf-afip' style={{ width: '-webkit-fill-available' }} src={urlPdf} height='500' />
          )}
        </div>
      </DialogContent>
    )
  }
}
